import { render, staticRenderFns } from "./compMainTask.vue?vue&type=template&id=30ecdcf6&"
import script from "./compMainTask.vue?vue&type=script&lang=js&"
export * from "./compMainTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30ecdcf6')) {
      api.createRecord('30ecdcf6', component.options)
    } else {
      api.reload('30ecdcf6', component.options)
    }
    module.hot.accept("./compMainTask.vue?vue&type=template&id=30ecdcf6&", function () {
      api.rerender('30ecdcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compMainTask.vue"
export default component.exports